module.exports = __webpack_public_path__ + "img/customer_service.659356c4.svg";